import gql from 'graphql-tag';

export const CREATE_PARTNER_ACCOUNT = gql`
  mutation CreatePartnerAccount($input: CreatePartnerProfileInput!) {
    result: createPartnerAccount(input: $input) {
      error
      success
      entity {
        id
      }
    }
  }
`;
